import React from 'react';
import { withRouter } from 'react-router-dom';
import ProgressiveImage from 'react-progressive-image';

class BannerSlide extends React.PureComponent {
  render() {
    const { project, slider } = this.props;
    const {
      title, original, tiny, embedUrl,
    } = project;

    const video = embedUrl ? `https://www.youtube.com/watch?v=${embedUrl}` : null;
    return (
      <div>
        <div
          role="presentation"
          className="project_slide__link"
          onClick={() => {
            if (slider.canTapSlide) {
              if (video) {
                slider.showVideo();
              } else {
                slider.goFull();
              }
            } else {
              slider.canTapSlide = true;
            }
          }}
        >
          <ProgressiveImage src={original} placeholder={tiny}>
            {(src, loading) => (
              <div style={{ opacity: loading ? 0.5 : 1 }}>
                <img className="project_slide__image" src={src} alt={title} />
              </div>
            )}
          </ProgressiveImage>
        </div>
      </div>
    );
  }
}
export default withRouter(BannerSlide);



// WEBPACK FOOTER //
// ./src/components/Sliders/BannerSlide.js